<template lang="pug">
.box-content-classes-me
  .row
    .no-data.col-md-12.col-sm-12.col-xs-12 {{no_data}}
  .clearfix
</template>
<script>

export default {
  data() {
    return {
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">

@media (max-width: 1366px){
 
}
@media (max-width: 1024px){
 
}
@media (max-width: 991px){
  
}
@media (max-width: 768px){
  
}
@media (max-width: 560px){
  
}
@media (max-width: 375px){
  
}
</style>




// WEBPACK FOOTER //
// index.vue?55ee8260